import { useEffect } from "react";
import { PageControl, KIND } from "baseui/page-control";
import { useNavigate } from 'react-router-dom';
import { Analytics,Gtag } from '../../compornents/Analytics';
import React from 'react';

// サービスの流れ STEP.4/4（bag-first改定 2026-09-01）。
// 改定前は「バッグを依頼→受け取る」の2枚だったが、新動線では
// 「バッグが届く → 入れる → 自分で集荷を依頼する → 届く」の4工程になる。
// 特にSTEP.1で「最初の配達はバッグであって、依頼品はまだ渡せない」ことを
// 注文前から刷り込んでおくのが、この改定で最も重要な役割。
export const RegisterStep4 = () => {
  const navigate = useNavigate();

  const next = () => {
    // 承認モックの順序: STEPスライド → 郵便番号(エリア確認) → メニュー → 電話番号。
    // 以前ここが /register/menu 直行になっており、エリア確認がスキップされていた（2026-09-01修正）。
    navigate('/register/postcode');
  }

  useEffect(() => {
    Gtag('view_register_step4');
  }, []);

  return (
    <div>
      <div>
        <Analytics title="Step4" />
        <div className="Register">
          <div className="App-step1">
            <div className="App-h1 pt-4">{"STEP.4"}</div>
            <img src="/img/step4.png" alt="ご自宅へお届け" className="App-img" />
            <div className="App-title-sm">キレイになってお届け</div>
            <div className="App-comment">{"クリーニングが完了したらお知らせします。\n受け取り依頼で、すぐにご自宅までお届けします。"}</div>
            <div className="App-h3">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '20px',
                }}
              >
                <PageControl
                  currentPage={4}
                  numPages={4}
                  kind={KIND.default}
                  aria-label="label"
                />
              </div>
              <button className="button-next-w" onClick={next}>{"はじめる"}</button>
              <div><img src="../img/Direct_delivered with_Uber Eats_horiz_pill_green_en_1@2x.png" className="ud_img" alt="ud logo" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
